// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-containers-Profile-DefaultChampionat-styles--item--WhUFh {
  padding-left: 0;
  padding-right: 0;
}
.src-containers-Profile-DefaultChampionat-styles--item--WhUFh:last-child {
    border-bottom: 0;
  }
`, "",{"version":3,"sources":["webpack://./src/containers/Profile/DefaultChampionat/styles.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAKlB;AAHE;IACE,gBAAgB;EAClB","sourcesContent":[".item {\n  padding-left: 0;\n  padding-right: 0;\n\n  &:last-child {\n    border-bottom: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `src-containers-Profile-DefaultChampionat-styles--item--WhUFh`
};
module.exports = ___CSS_LOADER_EXPORT___;
